module.exports = __webpack_public_path__ + "static/media/guadalupe_panaderia.6b01870a.png";